import { V2_ENDPOINT } from "@/consts";

// ─── Per-workflow webhook utilities ──────────────────────────────────

/**
 * Generate webhook URL for a workflow using its per-workflow secret.
 * The secret in the URL authenticates and identifies the workflow directly.
 *
 * @param workflowId - The workflow ID
 * @param secret - The workflow's webhook secret
 * @returns The complete webhook URL
 */
export function generatePerWorkflowWebhookUrl(workflowId: string, secret: string): string {
  return `${V2_ENDPOINT}/v1/workflows/${workflowId}/webhook?secret=${secret}`;
}

/**
 * Generate curl command for triggering a per-workflow webhook.
 *
 * @param workflowId - The workflow ID
 * @param secret - The workflow's webhook secret
 * @param exampleBody - Optional custom example body to show in the curl command
 * @returns The complete curl command
 */
export function generatePerWorkflowCurlCommand(
  workflowId: string,
  secret: string,
  exampleBody?: Record<string, unknown>,
): string {
  const url = generatePerWorkflowWebhookUrl(workflowId, secret);
  const body = exampleBody
    ? JSON.stringify({ data: exampleBody }, null, 2)
    : JSON.stringify({ data: { key: "value" } }, null, 2);
  return `curl -X POST '${url}' \\\n  -H 'Content-Type: application/json' \\\n  -d '${body}'`;
}
